import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  createPostModal: boolean;
}

const initialState: AuthState = {
  createPostModal: false,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    setCreatePostModalState: (state, action: PayloadAction<boolean>) => {
      state.createPostModal = action.payload;
    },
  },
});

export const { setCreatePostModalState } = modalSlice.actions;

export default modalSlice.reducer;
